import { SecurityService } from './security.service';
import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root'
})

export class CadastroVendedorService {


  constructor(
    private fns: AngularFireFunctions,
    private securityService: SecurityService) {

  }

  cadastrarVendedor(vendedor): Promise<any> {
    return new Promise(resolve => {
      const callable = this.fns.httpsCallable('appMartechCadastraVendedor');
      const data$ = callable({
        vendedor,
        currentUserEmail: this.securityService.currentUserValue.email
      });
      data$.subscribe(res => {
        console.log(res);
        resolve(res);
      });
    })

  }
}
